<div *ngIf="plan" class="description">
    <b style="font-size: large">
        {{ plan.price | currency: "BRL" }}
    </b>
    <div fxLayout="row">
        <div fxLayout="row">
            {{ "PLAN_DESCRIPTION.PLAN_EVERY" | translate }}&nbsp;<b>{{ plan?.intervalCount }}&nbsp;</b>
            <div *ngIf="plan?.interval == 'Months'">
                {{ "PLAN_DESCRIPTION.PLAN_INTERVAL_MOUNTH" | translate }}
            </div>
            <div *ngIf="plan?.interval == 'Days'">
                {{ "PLAN_DESCRIPTION.PLAN_INTERVAL_DAYS" | translate }}
            </div>
        </div>
    </div>
</div>
